/**
 * 首页相关接口
 */
import requestDefault from '@/shared/utils/request';
import type { MiddleIncomeData } from '@/pages/home/types';

/** 首页中收模块数据 */
// https://yapi.hellobike.cn/project/3415/interface/api/429605
// eslint-disable-next-line max-len
export const getMiddleIncomeData = (from: string): Promise<MiddleIncomeData> => requestDefault.postGate<MiddleIncomeData>(
  'f.homepage.middle.income',
  { from },
  { showLoading: undefined },
);
